import React, { useEffect, useMemo, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { imgUrl, siteUrl } from '../../config/config';
import { getGovernance } from '../../store/ducks/governance/actions';
import governanceSelector from '../../store/ducks/governance/selectors/governanceSelector';
import './Corporate.scss';
import { PageMeta } from 'components/PageMeta/PageMeta';

import { LangContext } from "../../components/App/App";

const Corporate = () => {

    const dispatch = useDispatch();
    const governance = useSelector(governanceSelector);
    const status = useSelector(state => state.governanceReducer.status);

    const lang = useContext(LangContext);
    useEffect(() => {
        if (lang && lang.lang && lang.lang.value && status === "IDLE") {
            dispatch(getGovernance({lang: lang.lang.value}));
        }
    }, [lang]);

    return (
        <>
            <PageMeta
                title={governance && governance.title}
                description="At FertiStream Holding Ltd, our corporate governance framework is designed to uphold our commitment to efficient, compliant, transparent, and ethical business practices. This framework governs FertiStream Holding Ltd, the parent entity of the FertiStream group, as well as all associated companies"
            />

            {governance && status && status === "SUCCESS" &&
                <>
                    <section className="corporate">
                        <div className="container">
                            <div className="corporate-wrapper">
                                <h1
                                    className="page-title"
                                    dangerouslySetInnerHTML={{__html: governance.title}}
                                />
                                <div
                                    className="page-descr"
                                    dangerouslySetInnerHTML={{__html: governance.description}}
                                />
                                <div className="corporate-img">
                                    <img
                                        src={siteUrl + governance.image}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    {governance.directors &&
                        <section className="board">
                            <div className="container">
                                <div className="board-wrapper">
                                    <h2
                                        className="section-title"
                                        dangerouslySetInnerHTML={{__html: governance.directors.title}}
                                    />
                                    <div className="board-info">
                                        <p dangerouslySetInnerHTML={{__html: governance.directors.preview}} />
                                        {governance.directors && governance.directors.directors && governance.directors.directors.length > 0 &&
                                            <div className="board-list">
                                                {governance.directors.directors.map(item => (
                                                    <div className="board-list__item" key={item.id}>
                                                        <div className="board-list__item-foto">
                                                            <img
                                                                src={siteUrl + item.photo}
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="board-list__item-info">
                                                            <div className="board-list__item-name">
                                                                {item.name}
                                                            </div>
                                                            <div className="board-list__item-pos">
                                                                {item.position}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                        <p dangerouslySetInnerHTML={{__html: governance.directors.text}} />
                                    </div>
                                </div>
                            </div>
                        </section>
                    }

                    {governance.documents &&
                        <section className="docs">
                            <div className="container">
                                <div className="docs-wrapper">
                                    <h2
                                        className="section-title"
                                        dangerouslySetInnerHTML={{__html: governance.documents.title}}
                                    />
                                    <div className="docs-list">
                                        <p dangerouslySetInnerHTML={{__html: governance.documents.preview}} />
                                        {governance.documents && governance.documents.documents && governance.documents.documents.length > 0 && governance.documents.documents.map(item => (
                                            <a
                                                key={item.id}
                                                target="_blank"
                                                href={siteUrl + item.url}
                                                className="docs-list__item"
                                            >
                                                <strong>{item.title}</strong>
                                                <span>{item.format}</span>
                                            </a>
                                        ))}
                                        <p dangerouslySetInnerHTML={{__html: governance.documents.text}} />
                                    </div>
                                </div>
                            </div>
                        </section>
                    }
                </>
            }
        </>
    );
};

export default Corporate;
